<app-device-features-container
  actionButtonName="{{
    '+INSTALLATIONS.INSTALLATION.FEATURE_CONTAINER.DETAILS_BUTTON' | translate
  }}"
  [header]="header"
  [overlayType]="availableOverlays.CallForHeatHeatingZone"
  [deviceSelectId]="deviceSelectId"
>
  <div header>
    <app-pill
      *ngIf="heatingPump$ | async | ready as feature"
      type="{{
        (feature | value2: featurePropertyKey.status) === 'on'
          ? pillType.success
          : pillType.secondary
      }}"
    >
      <ng-container *ngIf="feature.properties?.active?.value">
        {{ '+INSTALLATIONS.INSTALLATION.HEATING_ZONE.PUMP_ON_CHIP' | translate }}
      </ng-container>
      <ng-container *ngIf="!feature.properties?.active?.value">
        {{ '+INSTALLATIONS.INSTALLATION.HEATING_ZONE.PUMP_OFF_CHIP' | translate }}
      </ng-container>
    </app-pill>
  </div>

  <!-- heating.callForHeat.demand -->
  <app-feature-tile
    *ngIf="heatingDemand$ | async | ready as feature"
    feature
    label="{{ '+INSTALLATIONS.INSTALLATION.CIRCUIT.PROGRAM' | translate }}"
    [value]="
      installationFeaturesStore.callForHeatHeatingZoneOperatingProgramName$ | async | translate
    "
    [attr.data-feature]="feature.feature"
  ></app-feature-tile>

  <!-- heating.callForHeat.heating.curve.presets -->
  <ng-container feature *ngIf="heatingCurvePresets$ | async | ready as feature">
    <app-feature-tile
      *ngIf="feature | value2: featurePropertyKey.active"
      label="{{ '+INSTALLATIONS.INSTALLATION.HEATING_ZONE.PRESETS.TITLE' | translate }}"
      [value]="feature?.properties?.value?.value | translateHeatingCurvePresets"
      [attr.data-feature]="feature.feature"
    >
    </app-feature-tile>
  </ng-container>

  <!-- heating.callForHeat.configuration.regulation -->
  <app-feature-tile
    *ngIf="heatingConfigurationRegulation$ | async | ready as feature"
    feature
    label="{{
      '+INSTALLATIONS.INSTALLATION.HEATING_ZONE.CONFIGURATION_REGULATION.TITLE' | translate
    }}"
    [value]="feature.properties?.mode?.value | translateHeatingConfigurationRegulation"
    [attr.data-feature]="feature.feature"
  >
  </app-feature-tile>

  <!-- heating.callForHeat.sensors.temperature -->
  <app-feature-tile
    *ngIf="heatingSensorsTemperature$ | async | ready as feature"
    feature
    label="{{ '+INSTALLATIONS.INSTALLATION.HEATING_ZONE.FLOW_TEMPERATURE.TITLE' | translate }}"
    value="{{ feature | value2: featurePropertyKey.value }} {{
      feature | unit: featurePropertyKey.value
    }}"
    [attr.data-feature]="feature.feature"
    [error]="feature | error"
  >
  </app-feature-tile>
</app-device-features-container>
